// extracted by mini-css-extract-plugin
module.exports = {"toggle":"themeToggle_toggle__V6qJK"};